/*
 * Copyright 2025 Intuition Robotics ltd
 */
export const UnitNotRegisteredError = "UNIT_NOT_REGISTERED";
export const UnitIdWasInUseError = "UNIT_ID_WAS_IN_USE";
export const SerialNotAvailableError = "SERIAL_NOT_AVAILABLE";
export type UnitIdWasInUse = {error: string, hasFMContacts: boolean}